import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedReorder202605: FaireAdPerformancePeriodEntity =
  {
    token: "perf_p4_under_utilized_reorder_202605",
    type: "adPerformancePeriod",
    scope: "REORDER_MARKETPLACE",
    periodType: "RECEIPT",
    startDate: "2026-05-01",
    endDate: "2026-05-31",
    impressions: 3541,
    clicks: 56,
    adsSpendDollars: 405,
    budgetDollars: 500,
    salesDollars: 2988,
    bestEstimateRoas: 7.38,
    bestEstimateType: "ACTUALIZED",
    budgetUtilization: 0.81,
    reorderConversions: 8,
    dataAvailableAtDate: "2026-06-04",
    meta: {
      source: "mock",
      importedAt: "2026-07-06T00:00:00.000Z",
      importedBy: "advertiser-profiles",
    },
  };
